<template>
  <div
    class="gmf-customer-name"
    v-if="publicProfile && popupProfileCardEnabled"
  >
    <a
      href="#"
      class="gmf-link"
      @click.prevent.stop="openPopup"
      v-text="customerName"
    />
  </div>
  <div v-else
    class="gmf-customer-name"
    :class="popupProfileCardEnabled ? 'gmf-link-disabled' : null"
    v-text="customerName"
  />
</template>

<style scoped>
.gmf-customer-name, .gmf-customer-name > * {
  color: var(--gmf-col-name);
}
</style>

<script>
import state from '@/state';
import openPopupProfile from '@/components/PopupProfileCard/openPopupProfileCard';

const t = state.t;

export default {
  props: {
    customer: {
      Type: Object,
      default: () => null,
    },
    defaultPopupTab: {
      Type: String,
      default: 'profile',
    },
    disablePopup: {
      Type: Boolean,
      default: false,
    }
  },
  computed: {
    publicProfile () {
      const customer = this.customer;
      if (customer.merchantId && customer.merchantId !== state.merchantId) {
        return false;
      }
      return ! customer.isGuest;
    },
    popupProfileCardEnabled () {
      if (this.disablePopup) {
        return false;
      }
      return state.merchantConfig.popupProfileCard.enabled;
    },
    customerName () {
      const author = this.customer;
      if (author.firstName) {
        if (author.lastName) {
          return author.firstName + ' ' + author.lastName.slice(0,1);
        }
        return author.firstName;
      }
      if (author.name) {
        return author.name;
      }
      return t('comments.anonymous');
    },
  },
  methods: {
    openPopup () {
      if (! this.disablePopup) {
        openPopupProfile(this.customer.id, this.defaultPopupTab);
      }
    }
  },
};
</script>
